

















import Vue, { PropType } from 'vue';

// type DataType = {
//   checklist: Array<any>;
// };

export default Vue.extend({
  name: 'GCheckListDetail',
  props: {
    checklist: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    loading: Boolean as PropType<boolean>,
  },
  methods: {
    toTopPage() {
      window.location.href = '/ssr/';
    },
  },
});
